
import React, { useEffect, useState, Component } from 'react';
import { render } from 'react-dom';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { TextField } from 'office-ui-fabric-react/lib/TextField';

let resolve;

const classNames = mergeStyleSets({
    dialogContent: {
    }
});

const DialogContent = (props) => {

    const [value, setValue] = useState('');

    useEffect(() => {
        if (props.onChangeTitle) {
            props.onChangeTitle(value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    const handleChangeTitle = (event) => {
        setValue(event.target.value);
    }

    return (
        <div className={classNames.dialogContent}>
            <TextField
                label="Název kategorie parcel"
                value={value}
                onChange={handleChangeTitle}
            />
        </div>
    );
}

class DialogCreateCategory extends Component {

    static create() {
        const containerElement = document.createElement('div');
        document.body.appendChild(containerElement);
        return render(<DialogCreateCategory />, containerElement);
    }

    constructor(props) {
        super(props);
        this.state = {
            hidden: !props.show,
            title: ''
        };
    }

    checkValues() {
        let warnings = [];
        return (warnings.length === 0);
    }

    handleCancel = () => {
        this.setState({hidden: true});
        resolve(null);
    }

    handleConfirm = () => {
        if (this.checkValues()) {
            this.setState({hidden: true});
            resolve({
                title: this.state.title
            });
        }
    }

    handleChangeTitle = (title) => {
        this.setState({
            title: title
        });
    }

    render () {
        return (
            <Dialog
                hidden={this.state.hidden}
                minWidth={500}
                onDismiss={this.handleCancel}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: "Vytvořit novou kategorii parcel"
                }}
                modalProps={{
                    isBlocking: false
                }}
                >
                    <DialogContent
                        onChangeTitle={this.handleChangeTitle}
                    />
                <DialogFooter>
                    <PrimaryButton onClick={this.handleConfirm} text="Vytvořit" />
                    <DefaultButton onClick={this.handleCancel} text="Zrušit" />
                </DialogFooter>
            </Dialog>
        );
    }

    show() {
        this.setState({
            hidden: false,
            title: ''
        });
        return new Promise((res) => {
            resolve = res;
        });
    }
}

export default DialogCreateCategory.create();
